import script from "./Visit.vue?vue&type=script&setup=true&lang=js"
export * from "./Visit.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__